<template>
  <div class="content-main page-loading">
    <div class="loading">
      <van-loading type="spinner" />
      <span>code: {{code}}</span>
    </div>
  </div>
</template>

<script>
import { Loading } from 'vant'

export default{
  components: {
    [Loading.name]: Loading
  },
  data(){
    return {
      code: ""
    }
  },
  methods: {
    getUserinfoByCode(){
      var searchParams = new URLSearchParams(window.location.search)
      this.code = searchParams.get("code")
    },
    setHtmlFontSize () {
      const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
      const htmlDom = document.getElementsByTagName('html')[0]
      htmlDom.style.fontSize = htmlWidth / 10 + 'px'
    }
  },
  mounted(){
    this.setHtmlFontSize()
    // var searchParams = new URLSearchParams(window.location.search)
    // alert('destination: ' + searchParams.get("destination"))
    this.getUserinfoByCode()
  }
}
</script>

<style scoped>
.page-loading{
  font-size:28px;
  padding-top:30%;
  height:100vh;
}
/* .loading{
  font-size:12px;
  margin-top:30%;
} */
.van-loading{
  margin:0 auto;
  margin-bottom:15px;
}
</style>
